package ru.villawonka.app.presentation.design.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.Font
import org.jetbrains.compose.resources.FontResource
import villawonka.composeapp.generated.resources.*
import villawonka.composeapp.generated.resources.Res

val appFontFamily: FontFamily
    @Composable
    get() = FontFamily(
        Font(Res.font.NotoSans_Bold, FontWeight.Bold),
        Font(Res.font.NotoSans_Medium, FontWeight.Medium),
        Font(Res.font.NotoSans_Regular, FontWeight.Normal),
    )

object AppTextStyles {

    /**
     * Title large
     */

    val titleLargeBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 32.sp,
            lineHeight = 40.sp,
            fontFamily = appFontFamily,
        )

    val titleLargeMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 32.sp,
            lineHeight = 40.sp,
            fontFamily = appFontFamily,
        )

    val titleLargeRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 32.sp,
            lineHeight = 40.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Title medium
     */

    val titleMediumBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 24.sp,
            lineHeight = 34.sp,
            fontFamily = appFontFamily,
        )

    val titleMediumMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 24.sp,
            fontFamily = appFontFamily,
        )

    val titleMediumRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 24.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Title small
     */

    val titleSmallBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    val titleSmallMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    val titleSmallRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Label large
     */

    val labelLargeBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp,
            fontFamily = appFontFamily,
        )

    val labelLargeMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 16.sp,
            fontFamily = appFontFamily,
        )

    val labelLargeRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 16.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Label medium
     */

    val labelMediumBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 14.sp,
            lineHeight = 20.sp,
            fontFamily = appFontFamily,
        )

    val labelMediumMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 14.sp,
            lineHeight = 20.sp,
            fontFamily = appFontFamily,
        )

    val labelMediumRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 14.sp,
            lineHeight = 20.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Label small
     */

    val labelSmallBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 12.sp,
            lineHeight = 18.sp,
            fontFamily = appFontFamily,
        )

    val labelSmallMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 12.sp,
            fontFamily = appFontFamily,
        )

    val labelSmallRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 12.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Body large
     */

    val bodyLargeBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    val bodyLargeMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    val bodyLargeRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 20.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Body medium
     */

    val bodyMediumBold: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp,
            fontFamily = appFontFamily,
        )

    val bodyMediumMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 16.sp,
            lineHeight = 24.sp,
            fontFamily = appFontFamily,
        )

    val bodyMediumRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 16.sp,
            fontFamily = appFontFamily,
        )

    /**
     * Body small
     */

    val bodySmallBold : TextStyle
        @Composable
        get()= TextStyle(
            fontWeight = FontWeight.Bold,
            fontSize = 14.sp,
            fontFamily = appFontFamily,
        )

    val bodySmallMedium: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Medium,
            fontSize = 14.sp,
            fontFamily = appFontFamily,
        )

    val bodySmallRegular: TextStyle
        @Composable
        get() = TextStyle(
            fontWeight = FontWeight.Normal,
            fontSize = 14.sp,
            fontFamily = appFontFamily,
        )
}